import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "./Api";
import StaticFunctions from "../utils/StaticFunctions";

class CSVDownloadButton extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        columns: PropTypes.array.isRequired,
        data: PropTypes.array.isRequired,
    };

    static defaultProps = {
        fileName: 'MY.ZSK Report',
        csvTitle: [],
        separator: ';',
        fillGaps: '-',
        label: null,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.fileName = this.props.fileName.replace('.csv', '');
        this.newLineSeperator = '\n';
        this.label = (this.props.label) ? this.props.label : this.translate('csvDownloadLabel') + ' (CSV)';

    }

    addNewLines(number = 1) {

        let newLines = '';

        for (let i = 0; i < parseInt(number); i++) {
            newLines += this.newLineSeperator;
        }

        return newLines;

    }

    getColumnList(columns) {

        const excludedKeys = ['img', 'option', 'options'];
        const columnList = [];

        columns.forEach(
            (column) => {
                if (!excludedKeys.includes(column.key)) {
                    columnList.push({key: column.key, label: (column.name) ? column.name : this.translate(column.nameKey)});
                }
            }
        );

        return columnList;

    }

    getCsvContent() {

        const title = this.props.csvTitle;
        const columns = this.props.columns;
        const data = this.props.data;

        let csvContent = '';

        if (data) {
            for (let i in columns) {
                let csvTitle = (title[i]) ? title[i] : [];
                let csvColumns = (columns[i]) ? this.getCsvColumns(columns[i]) : [];
                let csvData = (data[i]) ? this.getCsvData(data[i], columns[i]) : [];

                if (csvTitle.length > 0) csvContent += csvTitle + this.addNewLines(2);
                if (csvColumns.length > 0) csvContent += csvColumns + this.addNewLines();
                if (csvData.length > 0) csvContent += csvData;
                if (csvData.length === 0) csvContent += this.translate('noDataFound');
                if (csvColumns.length > 0) csvContent += this.addNewLines(3);
            }
        }

        return csvContent;

    }

    getCsvColumns(columns) {

        const columnList = this.getColumnList(columns);

        return columnList.map(
            (column) => {
                return column.label;
            }
        ).join(this.props.separator);

    }

    getCsvData(data, columns) {

        const columnList = this.getColumnList(columns);
        const csvData = [];

        for (let i = 0; i < data.length; i++) {
            let dataTemp = data[i];
            let rowTemp = [];

            columnList.forEach(
                (column) => {
                    const value = (dataTemp.hasOwnProperty(column.key) && dataTemp[column.key] !== null && dataTemp[column.key] !== '') ? dataTemp[column.key] : this.props.fillGaps;

                    rowTemp.push((StaticFunctions.isDate(value)) ? "'" + value + "'" : value);
                }
            );

            csvData.push(rowTemp.join(this.props.separator));
        }

        return csvData.join(this.newLineSeperator);

    }

    render() {

        const csvContent = this.getCsvContent();

        if (!csvContent) return (
            <div>
                <button className="disabled-link">{this.label}</button>
            </div>
        );

        const name = StaticFunctions.getCurrentDate() + ' - ' + (this.fileName || 'ZSK Report') + '.csv';
/*
        const label = this.label;
        const encodedName = (this.fileName) ? window.btoa(JSON.stringify(this.fileName)) : '';
        const encodedData = (csvContent) ? window.btoa(JSON.stringify(csvContent)) : '';
        const url = this.api.fileSource({type: 'csv'});
*/
        return (
            <div>
                <a href={'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csvContent)} download={name} style={{padding: '2px 10px'}}>{this.label}</a>
            </div>
        );

    }

}

export default CSVDownloadButton;